import React, { useEffect, useState } from "react";
import { Drawer, Typography, Col, Row } from "antd";
// OPTIMIZED: Replaced @ant-design/icons with lightweight SVGs
import { CloseIcon } from "../Icons";
import Tile from "../../page/HomePage/TileContainer/Tile";
import MobileCard from "../Cards/MobileCard";
import { useMediaQuery } from "react-responsive";

const { Title } = Typography;

interface PavilionTurfsDrawerProps {
  visible: boolean;
  onClose: () => void;
  turfData: any[];
}

const PavilionTurfsDrawer: React.FC<PavilionTurfsDrawerProps> = ({ 
  visible, 
  onClose, 
  turfData 
}) => {
  const [pavilionTurfs, setPavilionTurfs] = useState<any[]>([]);
  
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  useEffect(() => {
    if (visible && turfData && turfData.length > 0) {
      // Data is already filtered, just set it
      setPavilionTurfs(turfData);
    } else {
      setPavilionTurfs([]);
    }
  }, [visible, turfData]);

  const handleClose = () => {
    setPavilionTurfs([]);
    onClose();
  };

  return (
    <Drawer
      open={visible}
      onClose={handleClose}
      placement="bottom"
      height="90%"
      className="pavilion-turfs-drawer"
      closeIcon={<CloseIcon size={20} color="#666" />}
      title={
        <div className="header-section">
          <Title level={2} className="drawer-title">
            Pavilion Turfs
          </Title>
          <p className="drawer-description">
            Discover our 3 premium pavilion turfs: Mahalaxmi Nagar, Nipania, and Dewas Naka
          </p>
        </div>
      }
    >
      <div className="drawer-content">
        {/* Render turf cards directly */}
        {pavilionTurfs.length > 0 ? (
          <Row
            style={{
              margin: "0 1rem 1rem 1rem",
              width: '100%',
            }}
            align={"stretch"}
            gutter={[24, 24]}
            wrap={true}
          >
            {pavilionTurfs.map((turfData, i) => {
              const isUnavailable = turfData.data?.isTurfUnavailable || false;
              return (
                <Col
                  xl={8} lg={12} md={12} sm={12} xs={24}
                  key={i}
                  data-card-index={i}
                >
                  {isMobile ? (
                    <MobileCard
                      {...turfData}
                      city={turfData.data?.city || 'Indore'}
                      isUnavailable={isUnavailable}
                      index={i}
                    />
                  ) : (
                    <Tile
                      {...turfData}
                      city={turfData.data?.city || 'Indore'}
                      isUnavailable={isUnavailable}
                      index={i}
                    />
                  )}
                </Col>
              );
            })}
          </Row>
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
            No pavilion turfs found
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default PavilionTurfsDrawer; 